import { memo, useEffect } from 'react';
import {
  TableDomesticPartnershipBodyVM,
  TableDomesticPartnershipVM,
} from 'practice/view-models/practice-edit-residence';
import { Grid, useEventCallback } from '@mui/material';
import { noop } from 'shell/utils/noop';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import AccordionNewReidenceForm from '../../accordion-residence/accordion-actual-residence/form';
import TableDomestic from './table-domestic';
import { FormikProps } from 'formik';
import { ModalDomesticVM } from '..';
import { TypeRegister } from 'practice/constants/type-register';
import { ResidenceID } from 'practice/constants/id-practice-edit-residence';

interface TableDomesticPartnershipProps {
  domesticPartnership?: Array<TableDomesticPartnershipBodyVM>;
  formContext: FormikProps<ModalDomesticVM>;
  typeRegister?: string;
}

const TableDomesticPartnershipComponent = ({
  domesticPartnership = [],
  formContext,
  typeRegister,
}: TableDomesticPartnershipProps): React.ReactElement => {
  const onChange = useEventCallback(
    (
      key: keyof TableDomesticPartnershipVM,
      value: TableDomesticPartnershipVM[keyof TableDomesticPartnershipVM]
    ) => {
      formContext.setFieldValue('tableDomesticPartnership', {
        ...(formContext.values.tableDomesticPartnership || {}),
        [key]: value,
      });
    }
  );

  useEffect(() => {
    if (domesticPartnership?.length > 0) {
      onChange('body', [...domesticPartnership]);
    }
  }, [domesticPartnership, onChange]);

  const onChangeTableDomesticPartnership = useEventCallback((table: TableDomesticPartnershipVM) => {
    formContext.setFieldValue('tableDomesticPartnership', table);
  });

  return (
    <Grid container spacing={2}>
      <TableDomestic
        tableDomesticPartnership={formContext.values.tableDomesticPartnership}
        onChangeTableDomesticPartnership={onChangeTableDomesticPartnership}
      />
      {formContext.values.tableDomesticPartnership?.residence ? (
        <>
          <Grid item xs={12}>
            <PmiTitleDivider>Residenza selezionata</PmiTitleDivider>
          </Grid>
          <Grid item xs={12}>
            <AccordionNewReidenceForm
              values={formContext.values.tableDomesticPartnership?.residence}
              disabled
              onChange={noop}
              isEmigr={typeRegister === TypeRegister.Emigration}
              typeResidence={ResidenceID.family}
            />
          </Grid>
        </>
      ) : undefined}
    </Grid>
  );
};

TableDomesticPartnershipComponent.displayName = 'Table Domestic Partnership';

const TableDomesticPartnership = memo(
  TableDomesticPartnershipComponent
) as typeof TableDomesticPartnershipComponent;

export default TableDomesticPartnership;
